import { BeehiivPublicationIds, BeehiivPublicationSlugs } from '@blockworks/platform/api/beehiiv';

import { Frequency, newsletterMetaBySlug } from './newsletter-meta';

export const newsletters = [
    {
        key: BeehiivPublicationIds.TheBreakdown,
        title: newsletterMetaBySlug[BeehiivPublicationSlugs.TheBreakdown].title,
        description: newsletterMetaBySlug[BeehiivPublicationSlugs.TheBreakdown].description,
        href: `/newsletter/${BeehiivPublicationSlugs.TheBreakdown}`,
        imageUrl: 'https://blockworks-co.imgix.net/wp-content/uploads/2025/04/TheBreakdown_landingPage.png',
        frequency: Frequency.Daily,
    },
    {
        key: BeehiivPublicationIds.ZeroXResearch,
        title: newsletterMetaBySlug[BeehiivPublicationSlugs.ZeroXResearch].title,
        description: newsletterMetaBySlug[BeehiivPublicationSlugs.ZeroXResearch].description,
        href: `/newsletter/${BeehiivPublicationSlugs.ZeroXResearch}`,
        imageUrl: 'https://blockworks-co.imgix.net/wp-content/uploads/2025/03/0xresearch-newsletter-img.png',
        frequency: Frequency.Weekdays,
    },
    {
        key: BeehiivPublicationIds.ForwardGuidance,
        title: newsletterMetaBySlug[BeehiivPublicationSlugs.ForwardGuidance].title,
        description: newsletterMetaBySlug[BeehiivPublicationSlugs.ForwardGuidance].description,
        href: `/newsletter/${BeehiivPublicationSlugs.ForwardGuidance}`,
        imageUrl: 'https://blockworks-co.imgix.net/wp-content/uploads/2025/03/ForwardGuidance-Newsletter-img.png',
        frequency: Frequency.Weekdays,
    },
    {
        key: BeehiivPublicationIds.Empire,
        title: newsletterMetaBySlug[BeehiivPublicationSlugs.Empire].title,
        description: newsletterMetaBySlug[BeehiivPublicationSlugs.Empire].description,
        href: `/newsletter/${BeehiivPublicationSlugs.Empire}`,
        imageUrl: 'https://blockworks-co.imgix.net/wp-content/uploads/2025/03/Empire-Newsletter-img-1.png',
        frequency: Frequency.Weekdays,
    },
    {
        key: BeehiivPublicationIds.Lightspeed,
        title: newsletterMetaBySlug[BeehiivPublicationSlugs.Lightspeed].title,
        description: newsletterMetaBySlug[BeehiivPublicationSlugs.Lightspeed].description,
        href: `/newsletter/${BeehiivPublicationSlugs.Lightspeed}`,
        imageUrl: 'https://blockworks-co.imgix.net/wp-content/uploads/2025/03/lightspeed-newsletter-img.png',
        frequency: Frequency.Weekdays,
    },
    {
        key: BeehiivPublicationIds.TheDrop,
        title: newsletterMetaBySlug[BeehiivPublicationSlugs.TheDrop].title,
        description: newsletterMetaBySlug[BeehiivPublicationSlugs.TheDrop].description,
        href: `/newsletter/${BeehiivPublicationSlugs.TheDrop}`,
        imageUrl: 'https://blockworks-co.imgix.net/wp-content/uploads/2025/03/the-drop-newsletter-img.png',
        frequency: Frequency.Weekdays,
    },
    {
        key: BeehiivPublicationIds.SupplyShock,
        title: newsletterMetaBySlug[BeehiivPublicationSlugs.SupplyShock].title,
        description: newsletterMetaBySlug[BeehiivPublicationSlugs.SupplyShock].description,
        href: `/newsletter/${BeehiivPublicationSlugs.SupplyShock}`,
        imageUrl: 'https://blockworks-co.imgix.net/wp-content/uploads/2025/03/Supply_twitter_PFP_20250224a.png',
        frequency: Frequency.Weekdays,
    },
];
